import { Action } from '@ngrx/store';
import { RuleModel } from '../../models/RuleModel';

export const UPDATE_RULE_STATUS_SUCCESS = '[Rule] Rule Successfully Updated';

export class UpdateRuleStatusSuccessAction implements Action {
  readonly type = UPDATE_RULE_STATUS_SUCCESS;

  constructor(public payload: { rule: RuleModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/UpdateRuleStatusSuccessAction.ts